// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.container[data-v-05bdb886] {\n    width: 100%;\n    max-width: 1920px;\n    padding: 0 16px;\n    margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
